import { toast } from 'sonner';

/**
 * One notification policy for every screen (installed once in App.tsx), so the ~160 existing `toast.success(...)` /
 * `toast.error(...)` call sites inherit it without being edited.
 *
 *  - Successes share ONE slot: a newer success replaces the older one instead of stacking (rapid Packed > Dispatched >
 *    Out for Delivery used to pile up three toasts over the page's action buttons). They close after 3 s.
 *  - Errors keep their own slots and stay 10 s, so a refusal is readable and never pushed away by a success.
 *  - A caller that passes its own `id` or `duration` keeps it.
 */
export const SUCCESS_TOAST_ID = 'app-success';
export const TOAST_DURATION = { success: 3000, error: 10000 } as const;

let installed = false;

export function installToastPolicy(): void {
  if (installed) return;
  installed = true;

  const success = toast.success;
  const error = toast.error;

  toast.success = ((message, data) =>
    success(message, { id: SUCCESS_TOAST_ID, duration: TOAST_DURATION.success, ...data })) as typeof toast.success;
  toast.error = ((message, data) =>
    error(message, { duration: TOAST_DURATION.error, ...data })) as typeof toast.error;
}
